module.exports = __webpack_public_path__ + "static/averta-extrabold-baba60512b3b067223f213c5733e1b56.woff";